import React from "react"
import PropTypes from "prop-types"
import Icon from "../icon-v2"

const Button = ({
    className,
    label,
    accessibilityLabel,
    icon,
    iconType,
    variant,
    spacing,
    onClick,
    disabled,
    loading,
    dataName,
}) => (
    <button
    data-name={dataName}
        className={`
  ${className} 
  button-v2 button-v2${variant}
  ${spacing ? " button-v2--spacing" : ""}
  ${icon ? " button-v2--has-icon" : ""}
  ${loading ? " button-v2--loading" : ""}
`}
        onClick={onClick}
        type="button"
        title={accessibilityLabel}
        disabled={loading ? true : disabled}
    >
        <span className="btn__text">{loading ? "Loading..." : label}</span>
        {icon && (
            <div className="button-v2__icon">
                <Icon iconType={iconType} icon={icon} size="16" loading={loading} />
            </div>
        )}
    </button>
)

Button.defaultProps = {
    label: "",
    className: "",
    icon: "",
    onClick: () => { },
    accessibility_title: "",
    disabled: false,
    loading: false,
    dataName: "",
}

Button.propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    icon: PropTypes.string,
    onClick: PropTypes.func,
    accessibility_title: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    dataName: PropTypes.string,
}

export default Button
